exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo {\n  line-height: 70px;\n}\n\n.logo,\n.logo-mini,\n.logo-lg {\n  min-height: 70px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/header/header.component.css
// module id = ../../../../../src/app/main/header/header.component.css
// module chunks = main